import type { ServiceKind } from '../types/health.types';

/** One entry the Health page probes individually via `GET /health/service/{id}`. */
export interface HealthServiceInfo {
  /** Matches the gateway's service id / agent name. */
  id: string;
  label: string;
  kind: ServiceKind;
}

/**
 * The always-on platform services shown in the Health page's top section, each
 * probed independently via the gateway's per-service endpoint. Hardcoded (the
 * gateway exposes no list endpoint) — keep in sync with `_PLATFORM_SERVICES` in
 * platform-gateway's `health_routes.py`. Ids unconfigured in an environment
 * resolve to an "unavailable" card (the endpoint 404s).
 */
export const HEALTH_SERVICES: HealthServiceInfo[] = [
  { id: 'integration', label: 'Integration', kind: 'service' },
  { id: 'workflow', label: 'Workflow', kind: 'service' },
  { id: 'curation', label: 'Curation', kind: 'service' },
  { id: 'config', label: 'Config', kind: 'service' },
  { id: 'notification', label: 'Notification', kind: 'service' },
  { id: 'analytics', label: 'Analytics', kind: 'service' },
  { id: 'observability', label: 'Observability', kind: 'service' },
];

/**
 * The AI agents shown in the Health page's on-demand section. Ids are the
 * kebab-case agent names the gateway accepts at `GET /health/service/{id}`
 * (mirrors `config.agent_urls` in platform-gateway) — probing one cold-starts
 * that agent. Woken individually (click a card) or all at once ("Wake all"),
 * never on page load, to avoid a burst of agent cold starts.
 */
export const HEALTH_AGENTS: HealthServiceInfo[] = [
  { id: 'item-setup-agent', label: 'Item Setup', kind: 'agent' },
  { id: 'core-attribution-agent', label: 'Core Attribution', kind: 'agent' },
  { id: 'search-descriptor-agent', label: 'Search Descriptor', kind: 'agent' },
  { id: 'highlights-agent', label: 'Highlights', kind: 'agent' },
  { id: 'product-copy-agent', label: 'Product Copy', kind: 'agent' },
  { id: 'meta-copy-agent', label: 'Meta Copy', kind: 'agent' },
  { id: 'faq-agent', label: 'FAQ', kind: 'agent' },
  { id: 'google-agent', label: 'Google', kind: 'agent' },
  { id: 'retailer-mapping-agent', label: 'Retailer Mapping', kind: 'agent' },
  { id: 'data-scoring-agent', label: 'Data Scoring', kind: 'agent' },
  { id: 'meta-agent', label: 'Meta', kind: 'agent' },
];
